<template>
  <popup ref="popup" :loading="popupLoading" @beforeClose="close">
    <div slot="body" style="padding-top: 0">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true">
        <el-row>
          <el-col :span="24">
            <!-- 单选 -->
            <el-card v-for="(qu, idx1) in questionArray.t1" :key="idx1 + '1'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color:#CC0000">{{ qu.i + 1 }}.单选</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b>
              <b>{{ qu.question.title }}</b> <b>(</b> <b>{{ qu.flag }}</b><b>)</b>
              <div v-for="(ch, idx2) in qu.question.choiceList" :key="idx2 + '26'">
                <el-button :id="qu.id + ch.o" plain @click="singleChoice(qu, ch.o, idx1)">{{ ch.o }}.{{ ch.n }}
                </el-button>
              </div>
            </el-card>
            <!-- 多选 -->
            <el-card v-for="(qu, idx1) in questionArray.t2" :key="idx1 + '191'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color:#CC0000">{{ qu.i + 1 }}.多选</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b>
              <b>{{ qu.question.title }}</b> <b>(</b>
              <b v-for="(anr, idx2) in qu.flag" :key="idx2 + '842'">{{ anr }}</b><b>)</b>
              <div v-for="(ch, idx3) in qu.question.choiceList" :key="idx3 + '33'">
                <el-button plain :id="qu.id + ch.o" @click="moreChoice(qu, ch.o, idx1, idx3)">{{ ch.o }}.{{ ch.n
                }}</el-button>
              </div>
            </el-card>
            <!-- 判断 -->
            <el-card v-for="(qu, idx1) in questionArray.t3" :key="idx1 + '121'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color:#CC0000">{{ qu.i + 1 }}.判断</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b>
              <b>{{ qu.question.title }}</b> <br />
              <input v-model="studentAnswer[qu.i][idx1]" value="1" type="radio" :name="qu.id" />正确
              <input v-model="studentAnswer[qu.i][idx1]" value="0" type="radio" :name="qu.id" />错误
            </el-card>
            <!-- 填空 -->
            <el-card v-for="(qu, idx1) in questionArray.t4" :key="idx1 + '8111'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color:#CC0000">{{ qu.i + 1 }}.填空</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b> {{ qu.question.title }}
              <br /><br />
              <input type="text" v-model="studentAnswer[qu.i][idx1]" />
            </el-card>
            <el-card v-for="(qu, idx1) in questionArray.t5" :key="idx1 + '2522'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color:#CC0000">{{ qu.i + 1 }}.简答</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b>
              <b>{{ qu.question.title }}</b> <br />
              <textarea cols="100%" rows="5" v-model="studentAnswer[qu.i][idx1]"></textarea>
            </el-card>
            <el-card v-for="(qu, idx1) in questionArray.t6" :key="idx1 + '3343'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color:#CC0000">{{ qu.i + 1 }}.论述</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b>
              <b>{{ qu.question.title }}</b> <br />
              <textarea cols="100%" rows="5" v-model="studentAnswer[qu.i][idx1]"></textarea>
            </el-card>
            <el-card v-for="(qu, idx1) in questionArray.t7" :key="idx1 + '4244'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color:#CC0000">{{ qu.i + 1 }}.编程题</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b>
              <b>{{ qu.question.title }}</b> <br />
              <textarea cols="100%" rows="5" v-model="studentAnswer[qu.i][idx1]"></textarea>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-row>
        <el-col :span="21">
          <el-button type="primary" :loading="confirmLoading" @click="confirm()">{{stuAnwser?'修改作业':'提交作业'  }}    </el-button>
          <el-button type="warnning" @click="strongclose()">关闭</el-button>
        </el-col>
      </el-row>
    </div>
  </popup>
</template>
<script>
import popup from "@/components/popup/drawerPopupSta.vue";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import api from "@/api/exams/exams/exams.js";
import apiAnws from "@/api/exams/exams/answers.js";
export default {
  components: {
    popup,
    FillInTheBlanks,
  },
  data() {
    return {
      popupLoading: false,
      disabled: false,
      confirmLoading: false,
      parameter: {}, //exam
      exm: {},
      kid: "",
      stuid: "",
      formParameter: {},
      //题类型位置
      choice_question: { show: false },
      //题数组
      questionArray: { t1: [], t2: [], t3: [], t4: [], t5: [], t6: [], t7: [] },
      //学生答案对象
      studentAnswer: [],
      exp: "",
      stuAnwser: false
    };
  },

  methods: {
    //初始化学生答案对象
    initStudentAnswer() {

      api.getexpContent({ exid: this.kid }, (response) => {
        let questions = JSON.parse(response.data);
        //题型
        let content = JSON.parse(questions.content);

        this.typeTxArr = content.types;
        this.typeTxArr.forEach((v, i) => {
          //初始化答案
          let tcnt = content.qnums[i] * 1;
          let anws = [];
          for (let idx = 0; idx < tcnt; idx++) {
            anws.push(null);
          }
          //初始化题型存储数组
          this.studentAnswer.push(anws);
          this.questionArray[`t${v}`] = questions.contents[i].qid;
        });

        this.getOneAnwser()

      });
    }, getOneAnwser() {
      api.getOneAnswers({ kid: this.kid, sid: this.stuid }, (res) => {
        if (res.data) {
          this.stuAnwser = res.data;

          // 拿到改卷情况
          this.isjudged = res.data.isjudged;
          // 获取学生答案
          let anwrArr = JSON.parse(this.stuAnwser.answer);
          //取得以前提交的成绩
          // 获取试卷得分
       
          //把答案加到studentAnswer
          this.studentAnswer=anwrArr
          this.typeTxArr.forEach((v, i) => {
            let anwr = anwrArr[i];
            if (v == 1) {
              this.questionArray.t1.forEach((v1, i1) => {
                v1.flag = anwr[i1];
              });
            } else if (v == 2) {
              this.questionArray.t2.forEach((v1, i1) => {
                v1.flag = anwr[i1];
              });
            } else if (v == 3) {
              this.questionArray.t3.forEach((v1, i1) => {
                v1.flag = anwr[i1];
              });
            } else {
                //主观题
                this.questionArray[`t${v}`].forEach((v1, i1) => {
                v1.flag = anwr[i1];
              });
            }
          });

          //手动强制刷新
          this.$forceUpdate();
        }

      });
    },
    //单选赋值
    singleChoice(qu, choice, idx) {
      // 获取当前按钮
      const currentClass = document.getElementById(qu.id + choice);
      // 当前按钮的父亲DIV的兄弟们
      const btnParentBrother = currentClass.parentNode.parentNode.children;
      // 循环消除其他按钮颜色
      for (
        let i = btnParentBrother.length - 1;
        i > btnParentBrother.length - 5;
        i--
      ) {
        btnParentBrother[i].firstChild.style.backgroundColor = "white";
      }
      // 给当前按钮加背景色
      currentClass.style.backgroundColor = "skyblue";

      this.studentAnswer[qu.i][idx] = choice;
      qu.flag = choice;
      this.$forceUpdate();
    },
    //获取填空题的答案数组,并且绑定到studentAnswer.answer上
    getAnswerArr(answerArr, i) {
      this.studentAnswer[i.i][i.j] = answerArr;
    },

    //多选赋值
    moreChoice(question, choice, idx1, idx3) {
      if (question.flag) {
        if (question.flag[idx3] == choice) {
          this.$set(question.flag, idx3, "");
        } else {
          this.$set(question.flag, idx3, choice);
        }
      } else {
        this.$set(question, "flag", []);
        this.$set(question.flag, idx3, choice);
      }
      this.studentAnswer[question.i][idx1] = question.flag.join("");
      // 获取当前按钮
      const currentClass = document.getElementById(question.id + choice);
      // 给当前按钮加背景色
      if (currentClass.style.backgroundColor == "skyblue") {
        currentClass.style.backgroundColor = "white";
      } else {
        currentClass.style.backgroundColor = "skyblue";
      }
      this.$forceUpdate();
    },
    //打开弹框
    open(row, title, disabled) {
      this.exm = row
      this.kid = row.id;
      let me = this.$caches.user.get();
      this.stuid = me.id;
      //根据考试id取回试卷
      api.findPaperByKid({ kid: this.kid }, (res) => {
        //考试
        this.parameter = res.data.exm;

        //试卷ID
        this.expId = this.parameter.expid;

        //加载答案
        this.initStudentAnswer();

        this.$refs.popup.open(title, "100%");

        this.disabled = disabled;
      });
    },
    strongclose() {
      this.$refs.popup.closeCallback();
      this.clear();
    },

    close() {
      this.clear();
    },
    clear() {
      this.disabled = false;
      this.$refs.popup.closeCallback();
      //退出初始化参数
      this.popupLoading = false;
      this.disabled = false;
      this.confirmLoading = false;
      this.parameter = {};
      this.formParameter = {};
      // this.studentAnswer = [];
      this.choice_question = { show: false };
      this.questionArray = {
        t1: [],
        t2: [],
        t3: [],
        t4: [],
        t5: [],
        t6: [],
        t7: [],
      };
    },
    confirm() {
      this.$confirm("您确定要结束考试并提交试卷么?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.stuAnwser) {
            let parameter = {
              id: this.stuAnwser.id,
              answer: JSON.stringify(this.studentAnswer),
            };
            apiAnws.update(parameter, (res) => {
              this.$parent.list();
              this.clear();
              this.close();
            });

          } else {
            let parameter = {
              kid: this.kid,
              sid: this.stuid,
              cid: this.exm.cid,
              expid: this.exm.expid,
              type: 3,
              answer: JSON.stringify(this.studentAnswer),
            };
            apiAnws.save(parameter, (res) => {
              this.$parent.list();
              this.clear();
              this.close();
            });
          }

        })
        .catch(() => {
          this.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-card,
input[type="radio"],
textarea,
/deep/ .el-button {
  margin-top: 10px;
}

textarea {
  padding: 10px 5px;
}
</style>
